import { NgModule } from '@angular/core';
import { SubscriptionPlansComponent } from './subscription-plans.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  declarations: [
    SubscriptionPlansComponent
  ],
  imports: [
    MatTabsModule, MatCheckboxModule, MatDialogModule, MatCardModule,TranslateModule,RouterModule
    ,MatInputModule,MatIconModule,MatButtonModule,FormsModule,CommonModule,MatButtonToggleModule, MatRadioModule, MatTooltipModule
  ],
  exports: [
    SubscriptionPlansComponent
  ]
})
export class SubscriptionPlansModule { }
